import { QuestionnaireCategoryItemsItemOneOf as Question } from '@/api/generated-catch-backend/model';
import { AnimatePresence, motion } from 'motion/react';
import WhyWeAsk from '../survey-item/components/why-we-ask';
import { SurveyItem } from '../survey-item/survey-item';
import { OnNext } from '../types';

export function QuestionnaireCard({
  isWhyWeAskExpanded,
  setIsWhyWeAskExpanded,
  currentQuestion,
  handleNext,
}: {
  isWhyWeAskExpanded: boolean;
  setIsWhyWeAskExpanded: (isExpanded: boolean) => void;
  currentQuestion: Question;
  handleNext: OnNext;
}) {
  return (
    <div className="relative flex h-[85vh] w-full flex-col rounded-t-[28px] bg-white shadow-[0px_10px_100px_0px_rgba(85,94,104,0.1)] backdrop-blur-[10px] backdrop-filter">
      <AnimatePresence mode="wait">
        {!isWhyWeAskExpanded && (
          <motion.div
            key="questionnaire-content"
            initial={{ opacity: 1 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="questionnaire-card-content"
          >
            <div className="mx-auto flex pb-20 min-h-0 w-full max-w-[700px] flex-1 items-start justify-center overflow-y-auto">
              <AnimatePresence mode="wait">
                {currentQuestion && (
                  <div className="h-full w-full">
                    <SurveyItem
                      key={currentQuestion.slug}
                      surveyItem={currentQuestion}
                      onWhyWeAskExpand={() => setIsWhyWeAskExpanded(true)}
                      hideWhyWeAsk={isWhyWeAskExpanded}
                      onNext={handleNext}
                    />
                  </div>
                )}
              </AnimatePresence>
            </div>
          </motion.div>
        )}
        {isWhyWeAskExpanded && currentQuestion && (
          <WhyWeAsk
            key="why-we-ask-expanded"
            explanation={currentQuestion.whyWeAsk}
            isExpanded={isWhyWeAskExpanded}
            isFullScreen={true}
            onClose={() => setIsWhyWeAskExpanded(false)}
          />
        )}
      </AnimatePresence>
    </div>
  );
}
